import { useContext } from "react";
import { AppContext } from "../context/context";
import { EMPTY_STRING, UserType } from "../utils/constants";
import { userDetails } from "../utils/commonQueryTypes";

const useLoggedInUserDetails = (): { user_details: userDetails } => {
  const { state } = useContext(AppContext);

  let user = EMPTY_STRING;
  let userId = 0;

  if (state.claims) {
    if (state.claims.EMPLOYEE) {
      user = UserType.EMPLOYEE;
      userId = state.empLoginId;
    } else if (state.claims.EDUATE) {
      user = UserType.EDUATE;
      userId = state.eduateId;
    }
  }

  return {
    user_details: {
      user_type: user,
      id: userId,
    },
  };
};

export default useLoggedInUserDetails;
